import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnInit {
  nome = '';
  papel = '';
  isMarshManager = false;

  constructor(
    private readonly router: Router,
    private readonly sessionService: SessionService,
  ) {}

  ngOnInit(): void {
    this.nome = this.sessionService.getSession().name?.split(' ')![0] ?? '';
    switch (this.sessionService.getSession().role) {
      case ERoleAdminString.Doctor:
        this.papel = 'Atendente';
        break;
      case ERoleAdminString.Master:
        this.papel = 'Administrador';
        break;
      case ERoleAdminString.Admin:
        this.papel = 'Administrador Oliv-e';
        break;
      default:
        this.papel = 'Usuário';
        break;
    }

    this.checkMarshManager();
  }

  navigateToProfile(): void {
    this.router.navigate(['/dash/perfil']);
  }

  downloadManual(): void {
    window.open('https://app-olive-themes.s3.amazonaws.com/Manual-Dashboard-Olive.pdf', '_blank');
  }

  checkMarshManager(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const marshPartnerIds = ['3325df09-881c-4eda-99a3-47804465c935', 'b104ce6c-6af6-42f3-8e53-c2cf4628cf15'];
    if (marshPartnerIds.includes(partnerId)) {
      this.isMarshManager = true;
    }
  }
}
